import { Tsp } from "../../api/policy"
import { useGetAllTSPs } from "../../api/tsps/useGetAllTSPs.ts"
import { useApiForArray } from "./useApiForArray"

export const useTSPsList = () => {
  const [res, reload] = useGetAllTSPs({ status: `active` })
  return useApiForArray<Tsp, {}>(res, reload)
}
